
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/DodaFront/View/JobSearchDetail",
      function () {
        return require("private-next-pages/DodaFront/View/JobSearchDetail/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/DodaFront/View/JobSearchDetail"])
      });
    }
  